export default "__VITE_ASSET__9a740c79__"